module.exports = __webpack_public_path__ + "static/media/icon-trash.d7da9811.svg";